// extracted by mini-css-extract-plugin
module.exports = {"container":"_1bcb8571","arrow":"_ede7c16f"};